// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:1000px){.stockCodeSizeM{font-size:10px!important;width:50px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
